import { RadioGroup, Text } from '@sparemin/blockhead';
import { useCallback } from 'react';
import everyLine from 'assets/every-line.png';
import everySegment from 'assets/every-segment.png';
import { SPEAKER_FREQUENCY_UNSUPPORTED_EXPORT_FORMATS } from '../constants';
import { useExportTranscriptModalContext } from '../ExportTranscriptModalContext';
import * as S from './styles';

export interface SpeakerFrequencyProps {}

const SpeakerFrequency: React.FC<SpeakerFrequencyProps> = () => {
  const {
    format,
    downloadFormatting: { includeSpeakerLabelsForAllSegments },
    onDownloadFormattingChange,
  } = useExportTranscriptModalContext();

  const handleChange = useCallback(
    (value: string): void => {
      onDownloadFormattingChange(
        'includeSpeakerLabelsForAllSegments',
        value === 'line',
      );
    },
    [onDownloadFormattingChange],
  );

  return (
    <S.FormatContainer
      $isDisabled={SPEAKER_FREQUENCY_UNSUPPORTED_EXPORT_FORMATS.includes(
        format,
      )}
    >
      <Text variant="label" weight={700}>
        How often to display the speaker label:
      </Text>

      <RadioGroup
        orientation="horizontal"
        value={includeSpeakerLabelsForAllSegments ? 'line' : 'segment'}
        onChange={handleChange}
      >
        <RadioGroup.Option value="segment">Every segment</RadioGroup.Option>

        <RadioGroup.Option value="line">Every line</RadioGroup.Option>
      </RadioGroup>

      <div>
        <S.FrequencyImage src={everySegment} alt="Every segment" />

        <S.FrequencyImage src={everyLine} alt="Every line" />
      </div>
    </S.FormatContainer>
  );
};

export default SpeakerFrequency;
